import { useQuery } from "@tanstack/react-query"
import { ApplicationUserGet } from "../app/models/ApplicationUser"
import { Guid } from "../app/models/CustomType"
import { digitalManagerApi } from "../services/api"

export function useApplicationUsers(applicationId?: Guid) {
  const { data: applicationUsers = [], isLoading: isLoadingApplicationUsers } = useQuery({
    queryKey: ["applicationUsers", applicationId],
    queryFn: () =>
      digitalManagerApi
        .get<ApplicationUserGet[]>(`/applications/${applicationId}/users`)
        .then((r) => r.data),
    enabled: !!applicationId,
  })

  return {
    applicationUsers,
    isLoadingApplicationUsers,
  }
}
